import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  AccountBuyerGetAnimalsQuery,
  AccountBuyerGetAnimalsQueryVariables,
  AnimalTypeEnum,
} from '@gql/graphql';
import { SortOrder } from '@gql/graphql';
import { useMemo } from 'react';

export const ACCOUNT_BUYER_GET_ANIMALS = graphql(`
  query AccountBuyerGetAnimals(
    $orderBy: AnimalOrderByWithRelationAndSearchRelevanceInput!
    $where: AnimalWhereInput
  ) {
    accountMe {
      id
      animals(orderBy: $orderBy, where: $where) {
        ...BuyerAnimalInfo
      }
    }
  }
`);

export interface UseAccountBuyerGetAnimalsParams {
  archived?: boolean;
  animalType?: AnimalTypeEnum;
}

export const useAccountBuyerGetAnimals = (params?: UseAccountBuyerGetAnimalsParams) => {
  const { archived, animalType } = params ?? {};
  const variables = useMemo((): AccountBuyerGetAnimalsQueryVariables => {
    return {
      orderBy: { createdAt: SortOrder.desc },
      where: {
        AND: [
          ...(archived != null ? [{ archived: { equals: archived } }] : []),
          ...(animalType != null ? [{ type: { equals: animalType } }] : []),
        ],
      },
    };
  }, [animalType, archived]);

  const { data, error, loading } = useQuery<
    AccountBuyerGetAnimalsQuery,
    AccountBuyerGetAnimalsQueryVariables
  >(ACCOUNT_BUYER_GET_ANIMALS, {
    variables,
    ssr: false,
    fetchPolicy: 'cache-and-network',
  });

  return {
    animals: data?.accountMe?.animals,
    animalsError: error,
    animalsLoading: loading,
  };
};
